import React from "react";
import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { RISK_CHART_COLORS } from "../../utils/actionCardColors";

const MissionChartOptions = ({
  mShowGreen,
  setMShowGreen,
  mShowYellow,
  setMShowYellow,
  mShowRed,
  setMShowRed,
}) => (
  <Box className="risk-chart-options">
    <FormControlLabel
      control={
        <Checkbox
          checked={mShowGreen}
          onChange={() => setMShowGreen((v) => !v)}
          size="small"
          sx={{
            color: RISK_CHART_COLORS.green,
            "&.Mui-checked": { color: RISK_CHART_COLORS.green },
          }}
        />
      }
      label={
        <Typography variant="body2" color={RISK_CHART_COLORS.green}>
          Green
        </Typography>
      }
    />
    <FormControlLabel
      control={
        <Checkbox
          checked={mShowYellow}
          onChange={() => setMShowYellow((v) => !v)}
          size="small"
          sx={{
            color: RISK_CHART_COLORS.yellow,
            "&.Mui-checked": { color: RISK_CHART_COLORS.yellow },
          }}
        />
      }
      label={
        <Typography variant="body2" color={RISK_CHART_COLORS.yellow}>
          Yellow
        </Typography>
      }
    />
    <FormControlLabel
      control={
        <Checkbox
          checked={mShowRed}
          onChange={() => setMShowRed((v) => !v)}
          size="small"
          sx={{
            color: RISK_CHART_COLORS.red,
            "&.Mui-checked": { color: RISK_CHART_COLORS.red },
          }}
        />
      }
      label={
        <Typography variant="body2" color={RISK_CHART_COLORS.red}>
          Red
        </Typography>
      }
    />
  </Box>
);

export default MissionChartOptions;
